import { createListenerMiddleware, TypedStartListening } from '@reduxjs/toolkit'
import { API_CALL_SUCCESS } from '../actions/actionConstants'
import { FETCH_FINAL_FLIGHT_FARES } from '../actions/apiActionConstants'
import { addPromoCode, refetchCommissionPromoCode } from '../actions/CheckoutActions'
import { AppDispatch } from '../store'

function isFetchFinalFlightFaresSuccess(action: unknown): action is {
  type: string
  api: string
} {
  return !!action &&
    typeof action === 'object' &&
    'api' in action &&
    'type' in action &&
    action.api === FETCH_FINAL_FLIGHT_FARES &&
    action.type === API_CALL_SUCCESS
}

/**
 * Middleware that re-applies promo codes after flight seat selection updates
 * the cart totals via FETCH_FINAL_FLIGHT_FARES success action.
 */
const promoReapplicationMiddleware = createListenerMiddleware()

type AppStartListening = TypedStartListening<App.State, AppDispatch>
const startAppListening = promoReapplicationMiddleware.startListening as AppStartListening

startAppListening({
  predicate: (action) => isFetchFinalFlightFaresSuccess(action),
  effect: async(action, listenerApi) => {
    // Re-apply promo codes after the Redux state has been updated with the new seat prices
    const state = listenerApi.getState()
    const existingPromoCode = state.checkout.payment.promoCode

    if (existingPromoCode) {
      listenerApi.dispatch(addPromoCode(existingPromoCode))
    }

    // Also re-apply commission promo codes for agent hub
    listenerApi.dispatch(refetchCommissionPromoCode())
  },
})

export default promoReapplicationMiddleware
